import React, { type FC } from 'react';
import Arrow from './Arrow';
import { ArrowsContainer } from './styled';
import type { HandleDealCardCtaCallBack } from '../../types';
import { ClickEventNameEnum } from '../../../../Curiosity/Analytics/utils/ClickEventNameEnum';

type ArrowsProps = {
  itemsLength: number;
  selectedItem: number;
  galleryContainerNode: Element | null;
  isOverlay: boolean;
  useTransparency?: boolean;
  handleDealCardCtaCallBack: HandleDealCardCtaCallBack;
  isAlternativeDates?: boolean;
};

const Arrows: FC<ArrowsProps> = ({
  itemsLength,
  selectedItem,
  galleryContainerNode,
  isOverlay,
  handleDealCardCtaCallBack,
  useTransparency = true,
  isAlternativeDates,
}) => {
  if (itemsLength === 1) return null;
  const arrows = ['arrow-left', 'arrow-right'];

  const handleOnClick = (val: string) => {
    handleDealCardCtaCallBack({
      payload: {
        event_name:
          val === 'arrow-left'
            ? ClickEventNameEnum.SearchresultsCardGalleryPrev
            : ClickEventNameEnum.SearchresultsCardGalleryNext,
        event_subcontext: 'button',
      },
    });
  };

  return (
    <ArrowsContainer isOverlay={isOverlay}>
      {arrows.map((arrow) => (
        <Arrow
          key={arrow}
          className={arrow}
          itemsLength={itemsLength}
          selectedItem={selectedItem}
          isOverlay={isOverlay}
          galleryContainerNode={galleryContainerNode}
          handleOnClick={handleOnClick}
          useTransparency={useTransparency}
          isAlternativeDates={isAlternativeDates}
        />
      ))}
    </ArrowsContainer>
  );
};

export default Arrows;
